module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/205-switzerland-2857d6a12f0c2702b9ac5c41e31fc32f.svg";